import * as React from "react";
import _ from "lodash";

import { Datetime } from "src/library/components/Datetime";
import { InfoBar } from "src/library/components/InfoBar";
import { ITerminology } from "src/library/utils";

import { ICallOff } from "../api/call-off.api";

interface IProps {
  isLoading: boolean;
  data?: ICallOff | null;
  primaryAction?: JSX.Element | null;
  secondaryAction?: JSX.Element | null;
  terminology: ITerminology
}

const CallOffSideBar = ({
  isLoading, data, primaryAction, secondaryAction, terminology
}: IProps) => {
  const CallOffInfoItems = React.useMemo(() => {
    const items = [
      {
        label: "Name",
        value: data ? data.name : "-"
      },
      {
        label: "Customer Reference",
        value: data?.customerReference ? data.customerReference : "-"
      },
      {
        label: "Available Quantity",
        value: data ? data.currentQuantity : "-"
      },
      {
        label: "Start Date",
        value: data ? <Datetime date={data.startDate} /> : "-"
      },
      {
        label: "End Date",
        value: data?.endDate ? <Datetime date={data.endDate} /> : "-"
      },
      {
        label: "Customer Account Number",
        value: data?.customer?.accountNumber ? data.customer.accountNumber : "-"
      },
      {
        label: "Product Name",
        value: data?.product?.description ? data.product.description : "-"
      },
      {
        label: "Product Part Number",
        value: data?.product?.partNumber ? data.product.partNumber : "-"
      },
      {
        label: "Number of OrderLines",
        value: data?.orderLines ? data.orderLines.length : "-"
      },
      {
        label: "Total Quantity",
        value: data ? data.initialQuantity : "-"
      }
    ];

    return items;
  }, [ data ]);

  return (
    <InfoBar
      isLoading={isLoading}
      title={`${terminology.callOff?.singular.text ?? "Call off"} Information`}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      items={CallOffInfoItems}
    />
  );
};

export default CallOffSideBar;
